import cnContent from "./token/ko/cn.js";
import usContent from "./token/ko/us.js";
import jpContent from "./token/ko/jp.js";
import koContent from "./token/ko/ko.js";
import geContent from "./token/ko/ge.js";
import ukContent from "./token/ko/uk.js";
import uaeContent from "./token/ko/uae.js";
import frContent from "./token/ko/fr.js";
import sgContent from "./token/ko/sg.js";

import agreementContent from "./agreement/ko-kr.js";

export default {
  // ===== 헤더 =====
  "head.index": "홈",
  "head.product": "제품",
  "head.computeProduct": "컴퓨팅 제품",
  "head.computeProductDesc":
    "컴퓨팅 파워 값을 구매하여 글로벌 컴퓨팅 수익 획득",
  "head.rentalProduct": "임대 제품",
  "head.rentalProductDesc": "고성능 서버를 임대하여 안정적인 수익 창출",
  "head.rental": "임대",
  "head.about": "회사 소개",

  // ===== 사용자 드롭다운 메뉴 =====
  "menu.profile": "마이 페이지",
  "menu.security": "계정 보안",
  "menu.settings": "설정",
  "menu.products": "제품 목록",
  "menu.deposits": "입금 기록",
  "menu.withdraws": "출금 기록",
  "menu.walletLog": "거래 기록",
  "menu.logout": "로그아웃",
  "menu.logoutSuccess": "로그아웃 성공",

  // ===== 푸터 =====
  "footer.contactEmail": "연락 이메일",

  // ===== 홈페이지 =====
  "home.heroTitle1": "글로벌 뉴 컴퓨팅 로드",
  "home.heroTitle2": "트윈 휠 구동 부의 엔진",
  "home.heroDesc":
    "플랫폼은 Microsoft, OpenAI, DeepSeek 등 대형 모델 거대 기업이 사전에 임대를 확보한 성숙한 사이트를 우선적으로 선택합니다",
  "home.heroBtn": "지금 컴퓨팅 수익 획득 →",
  "home.statTrade": "일일 거래액",
  "home.statTradeValue": "10억+",
  "home.statReliability": "신뢰성",
  "home.statGlobal": "글로벌 서비스",
  "home.buildTitle1": "나만의",
  "home.buildTitle2": "전용 컴퓨팅 룸 구축",
  "home.buildDesc1":
    "독립 관리 · 독립 임대 · 투명한 수익 —— 저희는 운영 관리만 담당하며, ",
  "home.buildDesc2": "모든 수익은 건설자에게 귀속됩니다",
  "home.buildFeature1Title": "독립 관리",
  "home.buildFeature1Desc":
    "룸에 대한 완전한 통제권을 소유하며, 임대 전략과 가격을 자율적으로 결정할 수 있습니다",
  "home.buildFeature2Title": "투명한 수익",
  "home.buildFeature2Desc":
    "실시간 재무 데이터를 시각화하여 모든 수익을 명확하게 확인할 수 있습니다",
  "home.buildFeature3Title": "전문적인 운영",
  "home.buildFeature3Desc":
    "하드웨어 유지보수, 네트워크 보장, 24시간 365일 기술 지원을 제공합니다",
  "home.buildFeature4Title": "수익은 전부 귀하의 몫",
  "home.buildFeature4Desc":
    "기본 운영 비용을 제외한 모든 임대 수익은 건설자에게 귀속됩니다",
  "home.buildBtn": "지금 건설 →",
  "home.buildStatsTitle": "📈 건설 수익 개요",
  "home.buildStatsUpdate": "실시간 업데이트",
  "home.buildStatRooms": "완공된 컴퓨팅 룸",
  "home.buildStatServers": "운영 중인 서버",
  "home.buildStatProfit": "건설자 총 수익",
  "home.buildStatPayback": "평균 회수 기간",
  "home.buildStatMonth": "개월",
  "home.buildCta": "🎯 지금 참여하여 컴퓨팅 인프라 사업을 시작하세요",
  "home.buildCtaBtn": "자세히 보기",
  "home.featuresBadge": "✦ 핵심 강점",
  "home.featuresTitle1": "AETRIVOL을 ",
  "home.featuresTitle2": "선택해야 하는 이유",
  "home.feature1Title": "고효율·편리",
  "home.feature1Desc":
    "AETRIVOL은 자사의 강점을 활용하여 개인이 컴퓨팅 시대의 혜택을 누릴 수 있는 기회를 제공합니다",
  "home.feature2Title": "국가 수준의 보안",
  "home.feature2Desc":
    "다층 네트워크 보호, 암호화된 데이터 전송, 24시간 365일 보안 모니터링",
  "home.feature3Title": "고성능 하드웨어",
  "home.feature3Desc":
    "NVIDIA 최신 세대 GPU, 고속 NVMe 스토리지 및 DDR5 메모리 탑재",
  "home.feature4Title": "글로벌 노드",
  "home.feature4Desc":
    "아시아 태평양, 유럽, 북미 데이터 센터를 커버하며, 저지연 글로벌 가속화 제공",
  "home.appBadge": "📱 모바일",
  "home.appTitle": "출시 예정",
  "home.appDesc1": "AETRIVOL 모바일 앱이 곧 출시됩니다. ",
  "home.appDesc2": "언제 어디서나 컴퓨팅 시장 동향을 파악하고, ",
  "home.appDesc3": "원터치로 GPU 컴퓨팅 파워를 관리할 수 있습니다.",
  "home.appQrText": "QR 코드를 스캔하여 앱 다운로드",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "협력",
  "home.walletsTitle2": "파트너",
  "home.walletsDesc": "신뢰할 수 있는 지갑과 연결하여 자산을 안전하게 관리",
  "home.settleTitle1": "실시간",
  "home.settleTitle2": "정산 동향",
  "home.settleDesc": "글로벌 사용자의 실시간 수익 정산 현황",
  "home.modalTitle": "출시 예정",
  "home.modalDesc1": "현재 새로운 컴퓨팅 룸 건설 프로젝트가 없습니다",
  "home.modalDesc2": "관심과 지원에 감사드립니다!",
  "home.modalBtn": "확인",

  // ===== 홈페이지-컴퓨팅 국가 =====
  "tokenList.title1": "나만의",
  "tokenList.title2": "컴퓨팅 국가 선택",
  "tokenList.desc": "세계를 선도하는 컴퓨팅 국가, 저투자 고수익",
  "tokenList.buy": "지금 구매",
  "tokenList.more": "더 보기",
  "tokenList.tagHot": "🔥 인기",
  "tokenList.tagProfit": "💰 고수익",
  "tokenList.tagRecommend": "⭐ 추천",
  "tokenList.tagNew": "🆕 신제품",

  // ===== 홈페이지-서버 임대 =====
  "serverList.title1": "서버",
  "serverList.title2": "임대",
  "serverList.desc": "성숙된 고성능 서버로 초과 수익을 창출하세요",
  "serverList.dailyIncome": "일일 수익",
  "serverList.value": "서버 가치",
  "serverList.yield": "수익률",
  "serverList.gpu": "GPU",
  "serverList.vram": "비디오 메모리",
  "serverList.storage": "스토리지",
  "serverList.status": "상태",
  "serverList.available": "✅ 임대 가능",
  "serverList.full": "⏳ 만석",
  "serverList.countdown": "시작까지",
  "serverList.days": "일",
  "serverList.btnFull": "만석",
  "serverList.btnRent": "지금 임대 →",
  "serverList.btnWait": "시작 대기",
  "serverList.look": "상세 보기",
  "serverList.btnEnded": "종료됨",
  "serverList.more": "더 보기",
  "serverList.spec1": "입문형",
  "serverList.spec2": "라이트형",
  "serverList.spec3": "퍼포먼스형",
  "serverList.spec4": "플래그십형",
  "serverList.tagHot": "🔥 인기",
  "serverList.tagRecommend": "⭐ 추천",
  "serverList.tagNew": "🌟 신규 출시",

  // ===== 홈페이지-정산 캐러셀 =====
  "settle.amount": "정산 금액",
  "settle.status": "정산 완료",
  "settle.power": "컴퓨팅 파워 값",
  "settle.rental": "서버 임대",
  "settle.basic": "기본 수익",
  "settle.cycle": "사이클 수익",
  "settle.phase1": "1단계",
  "settle.phase2": "2단계",
  "settle.phase3": "3단계",
  "settle.phase4": "4단계",

  // ===== 멤버센터 =====
  "member.recharge": "충전",
  "member.withdraw": "출금",
  "member.tabProducts": "내 제품",
  "member.tabHistory": "기록",
  "member.tabWalletLog": "지갑 기록",
  "member.tabDeposits": "입금 기록",
  "member.tabWithdraws": "출금 기록",
  "member.tabAddresses": "출금 주소",
  "member.avatarAlt": "사용자 아바타",
  "member.settingsTitle": "설정",
  "member.logoutTitle": "로그아웃",
  "member.tabTokenProduct": "컴퓨팅 제품",
  "member.tabRentProduct": "임대 제품",

  // ===== 설정 페이지 =====
  "setting.back": "뒤로",
  "setting.title": "⚙️ 설정",
  "setting.menuProfile": "개인 정보",
  "setting.menuSecurity": "계정 보안",
  "setting.menuVerify": "계정 인증",
  "setting.menuChangePwd": "비밀번호 변경",
  "setting.menuTradePwd": "거래 비밀번호",
  "setting.getUserInfoFail": "사용자 정보를 가져오지 못했습니다",

  // ===== 설정 페이지-개인 정보 =====
  "profile.title": "개인 정보",
  "profile.subtitle": "기본 정보 관리",
  "profile.avatar": "아바타",
  "profile.avatarAlt": "아바타",
  "profile.changeAvatar": "아바타 변경",
  "profile.systemAvatar": "시스템 아바타",
  "profile.firstName": "이름",
  "profile.firstNamePlaceholder": "이름을 입력하세요",
  "profile.lastName": "성",
  "profile.lastNamePlaceholder": "성을 입력하세요",
  "profile.phone": "전화번호",
  "profile.phonePlaceholder": "전화번호를 입력하세요",
  "profile.address": "주소",
  "profile.addressPlaceholder": "주소를 입력하세요",
  "profile.saving": "저장 중...",
  "profile.saveInfo": "정보 저장",
  "profile.selectSystemAvatar": "시스템 아바타 선택",
  "profile.avatarAltNum": "아바타 {count}",
  "profile.selectImageFile": "이미지 파일을 선택하세요",
  "profile.imageTooLarge": "이미지 크기는 5MB를 초과할 수 없습니다",
  "profile.uploadFail": "업로드 실패",
  "profile.updateFail": "업데이트 실패",
  "profile.updateSuccess": "업데이트 성공",
  "profile.uploadFailNoPath": "업로드 실패, 이미지 주소를 가져오지 못했습니다",
  "profile.uploadFailRetry": "업로드 실패, 잠시 후 다시 시도하세요",
  "profile.saveFail": "저장 실패",
  "profile.saveSuccess": "저장 성공",
  "profile.saveFailRetry": "저장 실패, 잠시 후 다시 시도하세요",

  // ===== 설정 페이지-계정 인증 =====
  "verifyPanel.title": "계정 인증",
  "verifyPanel.subtitle": "계정 권한 및 신뢰 수준 향상",
  "verifyPanel.realName": "실명 인증",
  "verifyPanel.realNameDesc": "실명 인증 정보를 제출했습니다",
  "verifyPanel.verified": "인증 완료 ✓",
  "verifyPanel.goVerify": "인증하러 가기 →",

  // ===== 설정 페이지-계정 보안 =====
  "securityPanel.title": "계정 보안",
  "securityPanel.subtitle": "계정의 안전 보장",
  "securityPanel.phoneBind": "전화번호 연동",
  "securityPanel.phoneBound": "연동됨 {phone}",
  "securityPanel.notBound": "미연동",
  "securityPanel.emailBind": "이메일 연동",
  "securityPanel.emailBound": "연동됨 {email}",
  "securityPanel.twofa": "2단계 인증 (2FA)",
  "securityPanel.twofaOn": "활성화됨 · 로그인 시마다 동적 인증 코드 필요",
  "securityPanel.twofaOff": "비활성화됨 · 계정 보안 강화를 위해 활성화 권장",
  "securityPanel.twofaEnabled": "활성화됨 ✓",
  "securityPanel.enableTwofa": "2단계 인증 활성화",
  "securityPanel.disableTwofaTitle": "2단계 인증 비활성화",
  "securityPanel.enableTwofaTitle": "2단계 인증 활성화",
  "securityPanel.qrAlt": "2단계 인증 QR 코드",
  "securityPanel.tip1":
    "1. Google Authenticator 또는 Microsoft Authenticator 다운로드",
  "securityPanel.tip2": "2. 위의 QR 코드 스캔 또는 시크릿 키 입력",
  "securityPanel.copy": "복사",
  "securityPanel.verifyCode": "인증 코드",
  "securityPanel.verifyCodePlaceholder": "6자리 동적 인증 코드 입력",
  "securityPanel.emailCode": "이메일 인증 코드",
  "securityPanel.emailCodePlaceholder": "이메일 인증 코드 입력",
  "securityPanel.resend": "{count}초 후 재전송",
  "securityPanel.sendCode": "인증 코드 전송",
  "securityPanel.disableWarning1":
    "2단계 인증을 비활성화하면 계정의 추가 보안 보호가 사라집니다.",
  "securityPanel.disableWarning2": "2단계 인증을 비활성화하시겠습니까?",
  "securityPanel.cancel": "취소",
  "securityPanel.confirmDisable": "비활성화 확인",
  "securityPanel.confirmEnable": "활성화 확인",
  "securityPanel.getSecretFail": "시크릿 키를 가져오지 못했습니다",
  "securityPanel.copySuccess": "시크릿 키가 클립보드에 복사되었습니다",
  "securityPanel.copyFail": "시크릿 키 복사에 실패했습니다",
  "securityPanel.enterVerifyCode": "6자리 동적 인증 코드를 입력하세요",
  "securityPanel.operationFail": "작업 실패",
  "securityPanel.twofaEnabledMsg": "2단계 인증이 활성화되었습니다!",
  "securityPanel.twofaDisabledMsg": "2단계 인증이 비활성화되었습니다!",
  "securityPanel.enterEmailCode": "이메일 인증 코드를 입력하세요",

  // ===== 설정 페이지-비밀번호 변경 =====
  "changePwd.title": "비밀번호 변경",
  "changePwd.subtitle": "정기적인 비밀번호 변경으로 계정 보안 유지",
  "changePwd.warning":
    "2단계 인증이 활성화되지 않아 비밀번호를 변경할 수 없습니다. 먼저 2단계 인증을 활성화하세요.",
  "changePwd.goEnable": "활성화하러 가기",
  "changePwd.newPwd": "새 비밀번호",
  "changePwd.newPwdPlaceholder": "새 비밀번호 입력 (6자 이상)",
  "changePwd.confirmPwd": "새 비밀번호 확인",
  "changePwd.confirmPwdPlaceholder": "새 비밀번호 다시 입력",
  "changePwd.emailCode": "이메일 인증 코드",
  "changePwd.emailCodePlaceholder": "이메일 인증 코드 입력",
  "changePwd.resend": "{count}초 후 재전송",
  "changePwd.sendCode": "인증 코드 전송",
  "changePwd.confirmBtn": "변경 확인",
  "changePwd.twofaDesc":
    "이메일 인증 코드를 전송하려면 2단계 인증 코드를 입력하세요",
  "changePwd.pwdTooShort": "새 비밀번호는 6자 이상이어야 합니다",
  "changePwd.pwdMismatch": "입력한 새 비밀번호가 일치하지 않습니다",
  "changePwd.enableTwofaFirst":
    "비밀번호를 변경하려면 먼저 2단계 인증을 활성화하세요",
  "changePwd.codeError": "인증 코드가 올바르지 않습니다",
  "changePwd.enterEmailCode": "이메일 인증 코드를 입력하세요",
  "changePwd.success": "비밀번호가 변경되었습니다! 다시 로그인하세요",

  // ===== 설정 페이지-거래 비밀번호 =====
  "tradePwd.title": "거래 비밀번호",
  "tradePwd.subtitle": "자산의 안전 보호",
  "tradePwd.warning":
    "2단계 인증이 활성화되지 않아 거래 비밀번호를 변경할 수 없습니다. 먼저 2단계 인증을 활성화하세요.",
  "tradePwd.goEnable": "활성화하러 가기",
  "tradePwd.newPwd": "새 거래 비밀번호",
  "tradePwd.newPwdPlaceholder": "새 거래 비밀번호 입력 (6자 이상)",
  "tradePwd.confirmPwd": "거래 비밀번호 확인",
  "tradePwd.confirmPwdPlaceholder": "새 거래 비밀번호 다시 입력",
  "tradePwd.emailCode": "이메일 인증 코드",
  "tradePwd.emailCodePlaceholder": "이메일 인증 코드 입력",
  "tradePwd.resend": "{count}초 후 재전송",
  "tradePwd.sendCode": "인증 코드 전송",
  "tradePwd.confirmBtn": "변경 확인",
  "tradePwd.twofaDesc":
    "이메일 인증 코드를 전송하려면 2단계 인증 코드를 입력하세요",
  "tradePwd.pwdTooShort": "새 거래 비밀번호는 6자 이상이어야 합니다",
  "tradePwd.pwdMismatch": "입력한 거래 비밀번호가 일치하지 않습니다",
  "tradePwd.enableTwofaFirst":
    "거래 비밀번호를 변경하려면 먼저 2단계 인증을 활성화하세요",
  "tradePwd.codeError": "인증 코드가 올바르지 않습니다",
  "tradePwd.enterEmailCode": "이메일 인증 코드를 입력하세요",
  "tradePwd.success": "거래 비밀번호가 변경되었습니다!",

  // ===== 멤버센터-기록 =====
  "history.tabToken": "컴퓨팅 기록",
  "history.tabRent": "임대 기록",

  // ===== 멤버센터-컴퓨팅 기록 =====
  "historyToken.type": "유형",
  "historyToken.allType": "모든 유형",
  "historyToken.buy": "구매",
  "historyToken.income": "수익",
  "historyToken.reset": "초기화",
  "historyToken.loading": "로딩 중...",
  "historyToken.empty": "제품이 없습니다",
  "historyToken.date": "날짜",
  "historyToken.product": "제품",
  "historyToken.quantity": "수량",
  "historyToken.amount": "금액",
  "historyToken.fee": "수수료",
  "historyToken.total": "합계",
  "historyToken.time": "시간",
  "historyToken.profit": "손익",
  "historyToken.deduct": "공제",
  "historyToken.profitPositive": "이익",
  "historyToken.profitNegative": "손실",
  "historyToken.unknownStatus": "알 수 없는 상태",
  "historyToken.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "historyToken.firstPage": "처음",
  "historyToken.prevPage": "이전",
  "historyToken.nextPage": "다음",
  "historyToken.lastPage": "마지막",
  "historyToken.perPage": "{count}건/페이지",

  // ===== 멤버센터-임대 기록 =====
  "historyServer.type": "유형",
  "historyServer.allType": "모든 유형",
  "historyServer.buy": "구매",
  "historyServer.income": "수익",
  "historyServer.reset": "초기화",
  "historyServer.loading": "로딩 중...",
  "historyServer.empty": "제품이 없습니다",
  "historyServer.date": "날짜",
  "historyServer.product": "제품",
  "historyServer.share": "지분",
  "historyServer.amount": "금액",
  "historyServer.fee": "수수료",
  "historyServer.total": "합계",
  "historyServer.time": "시간",
  "historyServer.unknownStatus": "알 수 없는 상태",
  "historyServer.paginationInfo":
    "총 {total}건 중 {page} / {totalPages} 페이지",
  "historyServer.firstPage": "처음",
  "historyServer.prevPage": "이전",
  "historyServer.nextPage": "다음",
  "historyServer.lastPage": "마지막",
  "historyServer.perPage": "{count}건/페이지",

  // ===== 멤버센터-입금 기록 =====
  "deposit.loading": "로딩 중...",
  "deposit.empty": "입금 기록이 없습니다",
  "deposit.coin": "코인",
  "deposit.quantity": "수량",
  "deposit.network": "네트워크",
  "deposit.address": "주소",
  "deposit.status": "상태",
  "deposit.time": "시간",
  "deposit.success": "성공",
  "deposit.processing": "처리 중",
  "deposit.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "deposit.firstPage": "처음",
  "deposit.prevPage": "이전",
  "deposit.nextPage": "다음",
  "deposit.lastPage": "마지막",
  "deposit.perPage": "{count}건/페이지",

  // ===== 멤버센터-출금 기록 =====
  "withdrawal.loading": "로딩 중...",
  "withdrawal.empty": "출금 기록이 없습니다",
  "withdrawal.coin": "코인",
  "withdrawal.quantity": "수량",
  "withdrawal.network": "네트워크",
  "withdrawal.address": "주소",
  "withdrawal.status": "상태",
  "withdrawal.time": "시간",
  "withdrawal.statusProcessing": "처리 중",
  "withdrawal.statusSuccess": "성공",
  "withdrawal.statusFailed": "실패",
  "withdrawal.statusUnknown": "알 수 없음",
  "withdrawal.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "withdrawal.firstPage": "처음",
  "withdrawal.prevPage": "이전",
  "withdrawal.nextPage": "다음",
  "withdrawal.lastPage": "마지막",
  "withdrawal.perPage": "{count}건/페이지",

  // ===== 멤버센터-출금 주소 =====
  "addresse.title": "출금 주소",
  "addresse.addAddress": "+ 주소 추가",
  "addresse.loading": "로딩 중...",
  "addresse.empty": "출금 주소가 없습니다",
  "addresse.coin": "코인",
  "addresse.network": "네트워크",
  "addresse.address": "주소",
  "addresse.time": "시간",
  "addresse.action": "작업",
  "addresse.delete": "삭제",
  "addresse.deleteSuccess": "삭제 성공",
  "addresse.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "addresse.firstPage": "처음",
  "addresse.prevPage": "이전",
  "addresse.nextPage": "다음",
  "addresse.lastPage": "마지막",
  "addresse.perPage": "{count}건/페이지",

  // ===== 멤버센터-지갑 기록 =====
  "walletLog.type": "유형",
  "walletLog.allType": "모든 유형",
  "walletLog.reset": "초기화",
  "walletLog.loading": "로딩 중...",
  "walletLog.empty": "제품이 없습니다",
  "walletLog.project": "프로젝트",
  "walletLog.amount": "금액",
  "walletLog.time": "시간",
  "walletLog.day": "일",
  "walletLog.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "walletLog.firstPage": "처음",
  "walletLog.prevPage": "이전",
  "walletLog.nextPage": "다음",
  "walletLog.lastPage": "마지막",
  "walletLog.perPage": "{count}건/페이지",
  "walletLog.typeDeposit": "입금",
  "walletLog.typeWithdraw": "출금",
  "walletLog.typePay": "결제",
  "walletLog.typeTokenIncome": "컴퓨팅 이익",
  "walletLog.typeTokenLoss": "컴퓨팅 손실",
  "walletLog.typeServerIncome": "서버 수익",
  "walletLog.typeTransferReturn": "출금 반환",
  "walletLog.typeFreezeBuy": "(구매) 동결",
  "walletLog.typeServerRent": "서버 임대료",
  "walletLog.typeUnfreeze": "(만료) 동결 해제",
  "walletLog.typeCompute": "컴퓨팅",
  "walletLog.typeRent": "임대",
  "walletLog.statusUnknown": "알 수 없는 상태",
  "walletLog.titlePower": "컴퓨팅 파워",
  "walletLog.titleRent": "임대",
  "walletLog.statusDeposit": "입금",
  "walletLog.statusWithdrawal": "출금",
  "walletLog.statusPay": "결제",
  "walletLog.statusPowerProfit": "컴퓨팅 이익",
  "walletLog.statusPowerLoss": "컴퓨팅 손실",
  "walletLog.statusServerIncome": "서버 수익",
  "walletLog.statusWithdrawalReturn": "출금 반환",
  "walletLog.statusPurchaseFreeze": "(구매) 동결",
  "walletLog.statusServerRent": "서버 임대료",
  "walletLog.statusExpireUnfreeze": "(만료) 동결 해제",

  // ===== 멤버센터-자산 개요 =====
  "memberBox.assetOverview": "자산 개요",
  "memberBox.realTime": "실시간 업데이트",
  "memberBox.totalAssets": "총 자산",
  "memberBox.vsYesterday": "전일 대비",
  "memberBox.availableBalance": "사용 가능 잔액",
  "memberBox.frozenFunds": "예치 자금",
  "memberBox.incomeTrend": "수익 트렌드",
  "memberBox.hashIncome": "컴퓨팅 수익",
  "memberBox.leaseIncome": "임대 수익",
  "memberBox.hashIncomeTotal": "컴퓨팅 수익 총액",
  "memberBox.leaseIncomeTotal": "임대 수익 총액",
  "memberBox.totalIncome": "총 수익",
  "memberBox.vsLastDay": "전일 대비",
  "memberBox.time7d": "7일",
  "memberBox.time15d": "15일",
  "memberBox.time30d": "30일",

  // ===== 멤버센터-제품 목록 =====
  "productToken.region": "지역",
  "productToken.allRegion": "모든 지역",
  "productToken.status": "상태",
  "productToken.allStatus": "모든 상태",
  "productToken.statusActive": "진행 중",
  "productToken.statusCompleted": "완료됨",
  "productToken.statusFrozen": "동결됨",
  "productToken.statusUnknown": "알 수 없는 상태",
  "productToken.reset": "초기화",
  "productToken.loading": "로딩 중...",
  "productToken.empty": "제품이 없습니다",
  "productToken.quantity": "수량",
  "productToken.period": "기간",
  "productToken.latestProfit": "최신 손익",
  "productToken.settledProfit": "정산 완료 손익",
  "productToken.periodProfit": "기간 손익",
  "productToken.totalProfit": "손익 총액",
  "productToken.action": "작업",
  "productToken.view": "보기",
  "productToken.day": "일",
  "productToken.paginationInfo": "총 {total}건 중 {page} / {totalPages} 페이지",
  "productToken.firstPage": "처음",
  "productToken.prevPage": "이전",
  "productToken.nextPage": "다음",
  "productToken.lastPage": "마지막",
  "productToken.perPage": "{count}건/페이지",
  "productToken.detailTitle": "제품 상세",
  "productToken.productCode": "제품 코드",
  "productToken.tradeInfo": "거래 정보",
  "productToken.tradeTime": "거래 시간",
  "productToken.buyPrice": "구매 가격",
  "productToken.principal": "원금",
  "productToken.fee": "수수료",
  "productToken.latestPrice": "최신 가격",
  "productToken.profitInfo": "손익 정보",
  "productToken.estimatedProfit": "추정 총 손익",
  "productToken.remark": "비고",
  "productToken.close": "닫기",

  // ===== 멤버센터-서버 제품 목록 =====
  "productServer.region": "지역",
  "productServer.allRegion": "모든 지역",
  "productServer.status": "상태",
  "productServer.allStatus": "모든 상태",
  "productServer.statusActive": "진행 중",
  "productServer.statusCompleted": "완료됨",
  "productServer.statusFrozen": "동결됨",
  "productServer.statusUnknown": "알 수 없는 상태",
  "productServer.reset": "초기화",
  "productServer.loading": "로딩 중...",
  "productServer.empty": "제품이 없습니다",
  "productServer.productName": "제품명",
  "productServer.share": "지분",
  "productServer.countdown": "카운트다운",
  "productServer.unsettledIncome": "미정산 수익",
  "productServer.settled": "정산됨",
  "productServer.totalIncome": "수익 총액",
  "productServer.action": "작업",
  "productServer.view": "보기",
  "productServer.day": "일",
  "productServer.paginationInfo":
    "총 {total}건 중 {page} / {totalPages} 페이지",
  "productServer.firstPage": "처음",
  "productServer.prevPage": "이전",
  "productServer.nextPage": "다음",
  "productServer.lastPage": "마지막",
  "productServer.perPage": "{count}건/페이지",
  "productServer.detailTitle": "제품 상세",
  "productServer.productCode": "제품 코드",
  "productServer.leaseInfo": "임대 정보",
  "productServer.leaseDate": "임대 날짜",
  "productServer.rent": "임대료",
  "productServer.maintenanceFee": "유지보수비",
  "productServer.profitInfo": "수익 정보",
  "productServer.estimatedLeaseIncome": "추정 총 임대 수익",
  "productServer.settledIncome": "정산 완료 수익",
  "productServer.phase": "{count}단계",
  "productServer.currentPhase": "현재 단계",
  "productServer.remark": "비고",
  "productServer.close": "닫기",

  // ===== 등록/자격 신청 페이지 =====
  "register.back": "로그인으로 돌아가기",
  "register.statusBadge": "자격 신청 · 수동 심사",
  "register.title": "자격 권리 신청",
  "register.subtitle":
    "자료 제출 후 24시간 이내에 심사를 완료하고 이메일로 알려드립니다",
  "register.basicInfo": "기본 정보",
  "register.firstNamePlaceholder": "이름을 입력하세요",
  "register.lastNamePlaceholder": "성을 입력하세요",
  "register.genderMale": "남성",
  "register.genderFemale": "여성",
  "register.genderSecret": "비공개",
  "register.birthdayPlaceholder": "생년월일을 선택하세요",
  "register.maritalStatus": "결혼 여부",
  "register.maritalUnmarried": "미혼",
  "register.maritalMarried": "기혼",
  "register.maritalDivorced": "이혼",
  "register.maritalWidowed": "사별",
  "register.contactAddress": "연락처 주소",
  "register.addressPlaceholder": "연락처 주소를 입력하세요",
  "register.occupationInfo": "직업 정보",
  "register.workUnitPlaceholder": "근무처를 입력하세요",
  "register.workAddressPlaceholder": "근무지 주소를 입력하세요",
  "register.occupationPlaceholder": "직업을 입력하세요",
  "register.incomePlaceholder": "연소득 범위를 선택하세요",
  "register.incomeBelow5": "5만 미만",
  "register.income5to10": "5만 - 10만",
  "register.income10to20": "10만 - 20만",
  "register.income20to50": "20만 - 50만",
  "register.income50to100": "50만 - 100만",
  "register.incomeAbove100": "100만 이상",
  "register.otherInfo": "기타 정보",
  "register.remarksPlaceholder":
    "기타 추가 설명 (선택 사항, 신청 사유, 특별 요구 사항 등)",
  "register.accountInfo": "계정 정보",
  "register.inviteCodePlaceholder": "확인 코드를 입력하세요",
  "register.emailPlaceholder":
    "이메일 주소를 입력하세요 (심사 결과가 이메일로 전송됩니다)",
  "register.verifyCodePlaceholder": "이메일 인증 코드를 입력하세요",
  "register.agreementText": "위 정보가 진실하고 유효함을 서약하며, ",
  "register.agreementLink": "《이용약관》",
  "register.auditNotice1": "제출 후 수동 심사를 진행합니다",
  "register.auditNotice2": "24시간 이내",
  "register.auditNotice3":
    " 에 이메일로 알려드립니다. 이메일 주소가 정확한지 확인하세요.",
  "register.submitBtn": "심사 신청 제출",
  "register.submitting": "제출 중...",
  "register.hasAccount": "이미 계정이 있으신가요?",
  "register.gotoLogin": "로그인하러 가기",
  "register.successTitle": "제출 완료!",
  "register.successDesc1": "자격 신청이 접수되었습니다. ",
  "register.successDesc2": "24시간 이내",
  "register.successDesc3": " 에 심사를 완료합니다.",
  "register.successDesc4": "심사 결과는 다음 이메일로 전송됩니다: ",
  "register.successTip": "이메일을 확인해주세요. 신청해 주셔서 감사합니다!",
  "register.modalBtn": "확인",
  "register.sending": "전송 중",
  "register.resendSuffix": "초 후 재전송",
  "register.auditNoticeMid": ", 심사 결과는 ",
  "register.invalidEmail": "유효한 이메일 주소를 입력하세요",
  "register.codeSent": "인증 코드가 이메일로 전송되었습니다. 확인해주세요",
  "register.inviteCodeInvalid": "6자리 초대 코드를 입력하세요",
  "register.verifyCodeInvalid": "4자리 이메일 인증 코드를 입력하세요",
  "register.firstNameRequired": "실명(이름)을 입력하세요",
  "register.lastNameRequired": "실명(성)을 입력하세요",
  "register.genderRequired": "성별을 선택하세요",
  "register.birthdayRequired": "생년월일을 선택하세요",
  "register.maritalRequired": "결혼 여부를 선택하세요",
  "register.addressRequired": "주소를 입력하세요",
  "register.workUnitRequired": "근무처를 입력하세요",
  "register.workAddressRequired": "근무지 주소를 입력하세요",
  "register.occupationRequired": "직업을 입력하세요",
  "register.incomeRequired": "연소득 범위를 선택하세요",
  "register.agreeRequired":
    "자격 심사 약관 및 개인정보 처리방침을 읽고 동의하세요",
  "register.registerFail": "등록 실패",
  "register.submitFail": "제출 실패, 잠시 후 다시 시도하세요",

  // ===== 로그인 페이지 =====
  "login.title": "AI 컴퓨팅 클라우드",
  "login.subtitle": "AI computing power cloud",
  "login.usernamePlaceholder": "사용자 이름을 입력하세요",
  "login.passwordPlaceholder": "비밀번호를 입력하세요",
  "login.forgotPassword": "비밀번호를 잊으셨나요?",
  "login.loginBtn": "로그인",
  "login.noQualification": "자격이 없으신가요?",
  "login.applyNow": "지금 자격 신청하기",
  "login.loginSuccess": "로그인 성공",
  "login.enterCredentials": "사용자 이름과 비밀번호를 입력하세요",
  "login.loading": "로딩 중...",

  // ===== 비밀번호 재설정 페이지 =====
  "reset.back": "로그인으로 돌아가기",
  "reset.title": "비밀번호 재설정",
  "reset.subtitleStep1": "신원을 확인하고 계정 비밀번호를 재설정합니다",
  "reset.subtitleStep2": "새 비밀번호를 설정하여 계정 보안을 유지하세요",
  "reset.emailPlaceholder": "등록된 이메일 주소를 입력하세요",
  "reset.captchaPlaceholder": "인증 코드를 입력하세요",
  "reset.sending": "전송 중",
  "reset.getCaptcha": "인증 코드 받기",
  "reset.nextStep": "다음",
  "reset.newPasswordPlaceholder": "새 비밀번호 설정 (6자 이상)",
  "reset.confirmPasswordPlaceholder": "새 비밀번호 다시 입력",
  "reset.resetBtn": "지금 재설정",
  "reset.rememberPassword": "비밀번호가 기억나시나요?",
  "reset.gotoLogin": "로그인하러 가기",
  "reset.invalidEmail": "유효한 이메일 주소를 입력하세요",
  "reset.captchaSent": "인증 코드가 전송되었습니다",
  "reset.captchaInvalid": "유효한 인증 코드를 입력하세요 (4자 이상)",
  "reset.passwordTooShort": "새 비밀번호는 6자 이상이어야 합니다",
  "reset.passwordMismatch": "입력한 비밀번호가 일치하지 않습니다",
  "reset.resetSuccess": "비밀번호가 재설정되었습니다! 다시 로그인하세요",

  // ===== 신원 인증 페이지 =====
  "verify.statusBadge": "신원 인증 · 정보 입력",
  "verify.title": "계정 인증",
  "verify.subtitle":
    "실제 신원 정보를 입력하세요. 제출 후 수동 심사를 진행합니다",
  "verify.accountSecurity": "계정 보안",
  "verify.loginPassword": "로그인 비밀번호",
  "verify.confirmLoginPassword": "로그인 비밀번호 확인",
  "verify.tradePassword": "거래 비밀번호",
  "verify.confirmTradePassword": "거래 비밀번호 확인",
  "verify.securityQuestion": "보안 질문",
  "verify.securityAnswer": "질문 답변",
  "verify.basicInfo": "기본 정보",
  "verify.country": "국적",
  "verify.countryPlaceholder": "국적을 선택하세요",
  "verify.phone": "전화번호",
  "verify.realName": "실명",
  "verify.idNumber": "신분증 번호",
  "verify.idPhoto": "신분증 사진",
  "verify.frontPhoto": "앞면 사진",
  "verify.backPhoto": "뒷면 사진",
  "verify.handPhoto": "신분증을 든 사진",
  "verify.uploading": "업로드 중...",
  "verify.clickUpload": "클릭하여 업로드",
  "verify.uploadHint": "JPG / PNG 지원, 5MB 이내 권장",
  "verify.uploadHandHint":
    "신분증을 손에 들고 얼굴과 신분증 정보가 선명하게 보이도록 촬영하세요",
  "verify.reupload": "다시 업로드",
  "verify.auditNotice1": "제출 후 수동 심사를 진행합니다",
  "verify.auditNoticeMid": ", 심사 결과는 ",
  "verify.auditNotice2": "24시간 이내",
  "verify.auditNotice3": " 에 알려드립니다. 정보가 정확한지 확인하세요.",
  "verify.submitBtn": "인증 제출",
  "verify.submitting": "제출 중...",
  "verify.hasAccount": "이미 계정이 있으신가요?",
  "verify.gotoLogin": "로그인하러 가기",
  "verify.successTitle": "제출 완료!",
  "verify.successDesc1": "인증 정보가 제출되었습니다. ",
  "verify.successDesc2": "24시간 이내",
  "verify.successDesc3": " 에 심사를 완료합니다.",
  "verify.successDesc4": "심사 결과는 SMS로 알려드립니다.",
  "verify.successTip":
    "전화가 연결될 수 있도록 해주세요. 협조해 주셔서 감사합니다!",
  "verify.modalBtn": "확인",
  "verify.loginPasswordPlaceholder": "로그인 비밀번호 설정 (6자 이상)",
  "verify.confirmLoginPasswordPlaceholder": "로그인 비밀번호 다시 입력",
  "verify.tradePasswordPlaceholder": "거래 비밀번호 설정 (6자 이상)",
  "verify.confirmTradePasswordPlaceholder": "거래 비밀번호 다시 입력",
  "verify.securityQuestionPlaceholder": "보안 질문을 입력하세요",
  "verify.securityAnswerPlaceholder": "질문에 대한 답변을 입력하세요",
  "verify.phonePlaceholder": "전화번호를 입력하세요",
  "verify.realNamePlaceholder": "실명 입력 (신분증과 동일)",
  "verify.idNumberPlaceholder": "신분증 번호를 입력하세요",
  "verify.uploadImage": "이미지 파일을 업로드하세요",
  "verify.imageTooLarge": "이미지 크기는 5MB를 초과할 수 없습니다",
  "verify.uploadSuccess": "이미지 업로드 성공",
  "verify.uploadFail": "이미지 업로드 실패",
  "verify.uploadFailRetry": "이미지 업로드 실패, 잠시 후 다시 시도하세요",
  "verify.passwordTooShort": "비밀번호는 6자 이상이어야 합니다",
  "verify.confirmPasswordRequired": "비밀번호를 다시 입력하세요",
  "verify.passwordMismatch": "입력한 비밀번호가 일치하지 않습니다",
  "verify.tradePasswordTooShort": "거래 비밀번호는 6자 이상이어야 합니다",
  "verify.confirmTradePasswordRequired": "거래 비밀번호를 다시 입력하세요",
  "verify.tradePasswordMismatch": "입력한 거래 비밀번호가 일치하지 않습니다",
  "verify.securityQuestionRequired": "보안 질문을 입력하세요",
  "verify.countryRequired": "국적을 선택하세요",
  "verify.phoneInvalid": "유효한 전화번호를 입력하세요",
  "verify.realNameRequired": "실명을 입력하세요 (2자 이상)",
  "verify.idNumberInvalid": "유효한 신분증 번호를 입력하세요",
  "verify.idFrontRequired": "신분증 앞면 사진을 업로드하세요",
  "verify.idBackRequired": "신분증 뒷면 사진을 업로드하세요",
  "verify.idHandRequired": "신분증을 든 사진을 업로드하세요",
  "verify.submitSuccess": "제출 성공",
  "verify.submitFail": "제출 실패",
  "verify.submitFailRetry": "제출 실패, 잠시 후 다시 시도하세요",

  // ===== 임대 목록 페이지 =====
  "rental.title1": "서버",
  "rental.title2": "임대",
  "rental.desc":
    "엄선된 고성능 서버에 투자하여 개인 컴퓨팅 자산을 구축하고 글로벌 컴퓨팅 발전을 지원하세요",
  "rental.statServers": "임대 가능 서버",
  "rental.statAvailability": "가용성",
  "rental.statSupport": "고객 지원",
  "rental.searchPlaceholder": "서버명, GPU 모델 검색...",
  "rental.filterAll": "전체",
  "rental.filterHot": "🔥 인기",
  "rental.filterRecommend": "⭐ 추천",
  "rental.filterNew": "🌟 신규 출시",
  "rental.sortDefault": "기본 정렬",
  "rental.sortRemainingAsc": "잔여 ↑",
  "rental.sortRemainingDesc": "잔여 ↓",
  "rental.sortValueAsc": "가치 ↑",
  "rental.sortValueDesc": "가치 ↓",
  "rental.sortStartAsc": "활동 시작 ↑",
  "rental.sortStartDesc": "활동 시작 ↓",
  "rental.sortEndAsc": "활동 종료 ↑",
  "rental.sortEndDesc": "활동 종료 ↓",
  "rental.resultCount": "총 {count}대의 서버",
  "rental.loading": "로딩 중...",
  "rental.empty": "해당 서버를 찾을 수 없습니다",
  "rental.totalValue": "총 가치",
  "rental.country": "국가",
  "rental.incomeTrend": "수익 트렌드",
  "rental.activityPeriod": "📅 기간",
  "rental.remaining": "⏳ 잔여",
  "rental.days": "일",
  "rental.memory": "메모리",
  "rental.storage": "스토리지",
  "rental.bandwidth": "대역폭",
  "rental.status": "상태",
  "rental.available": "✅ 임대 가능",
  "rental.full": "⏳ 만석",
  "rental.countdown": "시작까지",
  "rental.btnFull": "만석",
  "rental.btnRent": "지금 임대",
  "rental.btnWait": "시작 대기",
  "rental.btnEnded": "종료됨",
  "rental.btnRentList": "임대",
  "rental.btnNotStart": "시작 안됨",
  "rental.value": "가치",
  "rental.prev": "← 이전",
  "rental.next": "다음 →",
  "rental.perPage": "{count}건/페이지",
  "rental.processBadge": "📋 임대 프로세스",
  "rental.processTitle1": "3가지 간단한 ",
  "rental.processTitle2": "단계로 서버 임대",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "서버 선택",
  "rental.step1Desc": "서버 목록을 둘러보고 필요에 맞는 구성을 선택하세요",
  "rental.step2Icon": "📝",
  "rental.step2Title": "임대 신청 제출",
  "rental.step2Desc": "임대 기간, 용도 등의 정보를 입력하고 심사 제출",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "배포 및 사용",
  "rental.step3Desc": "심사 통과 후 즉시 배포하여 AI 컴퓨팅 여정을 시작하세요",
  "rental.ctaTitle": "적합한 서버를 찾지 못하셨나요?",
  "rental.ctaDesc":
    "맞춤형 솔루션은 문의해 주세요. 전문 팀이 최적의 구성을 추천해 드립니다",
  "rental.ctaContact": "고객 지원",
  "rental.ctaFaq": "자주 묻는 질문 보기",
  "rental.spec1": "입문형",
  "rental.spec2": "라이트형",
  "rental.spec3": "퍼포먼스형",
  "rental.spec4": "플래그십형",
  "rental.tagHot": "🔥 인기",
  "rental.tagRecommend": "⭐ 추천",
  "rental.tagNew": "🌟 신규 출시",
  "rental.statusActive": "진행 중",
  "rental.statusPending": "시작 안됨",
  "rental.statusEnded": "종료됨",
  "rental.income": "수익",
  "rental.progress": "진행률",
  "rental.countryAlt": "국가",
  "rental.monday": "월",
  "rental.tuesday": "화",
  "rental.wednesday": "수",
  "rental.thursday": "목",
  "rental.friday": "금",
  "rental.saturday": "토",
  "rental.sunday": "일",

  // ===== 출금 페이지 =====
  "withdraw.title": "💸 출금",
  "withdraw.desc": "신속한 출금, 안전한 입금",
  "withdraw.balance": "사용 가능 잔액",
  "withdraw.methodCrypto": "🪙 암호화폐",
  "withdraw.methodBank": "🏦 은행 출금",
  "withdraw.selectCoin": "코인 선택",
  "withdraw.selectNetwork": "출금 네트워크 선택",
  "withdraw.address": "출금 주소",
  "withdraw.bindAddress": "➕ 주소 연동",
  "withdraw.selectAddress": "출금 주소를 선택하세요",
  "withdraw.noAddress": "사용 가능한 주소가 없습니다",
  "withdraw.noAddressTip": "⚠️ 연동된 {coin} 주소가 없습니다. 먼저 ",
  "withdraw.bindLink": "주소 연동",
  "withdraw.amount": "출금 금액",
  "withdraw.emailCode": "이메일 인증 코드",
  "withdraw.emailCodePlaceholder": "이메일 인증 코드 입력",
  "withdraw.resend": "{count}초 후 재전송",
  "withdraw.sendCode": "인증 코드 전송",
  "withdraw.expectedArrival": "예상 입금",
  "withdraw.networkFee": "네트워크 수수료",
  "withdraw.actualArrival": "실제 입금",
  "withdraw.submitting": "⏳ 전송 중...",
  "withdraw.confirm": "🚀 출금 확인",
  "withdraw.selectFirst": "👆 코인과 네트워크를 선택하세요",
  "withdraw.minAmount": "최소 출금액",
  "withdraw.maxAmount": "최대 출금액",
  "withdraw.all": "전체",
  "withdraw.available": "사용 가능",
  "withdraw.insufficientBalance": "잔액 부족",
  "withdraw.enterAmount": "출금 금액을 입력하세요",
  "withdraw.enterCode": "이메일 인증 코드를 입력하세요",
  "withdraw.selectAddressFirst": "출금 주소를 선택하세요",
  "withdraw.success": "출금 신청이 접수되었습니다",
  "withdraw.fail": "출금 실패",
  "withdraw.arrivalTime": "10~30분",
  "withdraw.noticeTitle": "📋 출금 시 주의사항",
  "withdraw.notice1Title": "입금 시간",
  "withdraw.notice1Desc":
    "암호화폐 출금은 일반적으로 10~30분 내에 입금됩니다. 블록체인 네트워크 확인 속도에 따라 다를 수 있습니다.",
  "withdraw.notice2Title": "최소 출금액",
  "withdraw.notice2Desc":
    "1회 출금 최소 금액은 0.001 BTC 또는 다른 코인의 등가 금액입니다. 이 금액 미만은 전송할 수 없습니다.",
  "withdraw.notice3Title": "주소 확인",
  "withdraw.notice3Desc":
    "출금 주소를 신중히 확인하세요. 잘못된 작업은 자산의 영구적 손실로 이어질 수 있으며, 플랫폼은 책임을 지지 않습니다.",
  "withdraw.notice4Title": "수수료 안내",
  "withdraw.notice4Desc":
    "출금 수수료는 블록체인 네트워크에 의해 결정되며, 플랫폼은 추가 수수료를 부과하지 않습니다. 수수료는 출금 금액에서 차감됩니다.",
  "withdraw.codeError": "인증 코드가 올바르지 않습니다",
  "withdraw.twoFactorDesc":
    "이메일 인증 코드를 전송하려면 2단계 인증 코드를 입력하세요",
  "withdraw.selectBank": "은행 계좌 선택",
  "withdraw.selectBankPlaceholder": "은행 계좌를 선택하세요",
  "withdraw.bankBOC": "중국은행",
  "withdraw.bankICBC": "공상은행",
  "withdraw.addBank": "+ 새 계좌 추가",
  "withdraw.bankAmount": "출금 금액 (USD)",
  "withdraw.exchangeRate": "💱 환율",
  "withdraw.arrivalTimeLabel": "⏱️ 입금 시간",
  "withdraw.bankArrivalTime": "1~3 영업일",
  "withdraw.bankConfirm": "🏦 출금 확인",
  "withdraw.bankSuccess":
    "🏦 은행 출금 신청이 접수되었습니다. 1~3 영업일 내에 입금됩니다",

  // ===== 입금 페이지 =====
  "depositPage.title": "💰 입금",
  "depositPage.desc": "입금 방법을 선택하여 빠르게 충전",
  "depositPage.balance": "현재 잔액",
  "depositPage.methodCrypto": "🪙 암호화폐",
  "depositPage.methodOnline": "💳 온라인 입금",
  "depositPage.coin": "코인",
  "depositPage.protocol": "프로토콜",
  "depositPage.qrAlt": "입금 QR 코드",
  "depositPage.qrPlaceholder": "QR 코드가 없습니다",
  "depositPage.copy": "📋 복사",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ <strong>{coin}</strong> ({protocol}) 전송만 지원합니다. 다른 자산은 전송하지 마세요",
  "depositPage.amountPlaceholder": "입금액 입력 (선택 사항)",
  "depositPage.transferBtn": "🚀 전송 완료",
  "depositPage.emptyState": "👆 코인과 프로토콜을 선택하세요",
  "depositPage.noticeTitle": "📋 입금 시 주의사항",
  "depositPage.onlineCardName1": "신용/직불 카드",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "결제 →",
  "depositPage.onlineCardName2": "은행 송금",
  "depositPage.onlineCardDesc2": "1~3 영업일 입금",
  "depositPage.onlineCardBtn2": "정보 받기 →",
  "depositPage.onlineCardName3": "제3자 결제",
  "depositPage.onlineCardDesc3": "알리페이 · 위챗 · Paypal",
  "depositPage.onlineCardBtn3": "결제 →",
  "depositPage.notice1Title": "입금 시간",
  "depositPage.notice1Desc":
    "암호화폐 입금은 블록체인 네트워크 확인이 필요하며, 일반적으로 10~30분이 소요됩니다. 네트워크 혼잡도에 따라 다를 수 있습니다.",
  "depositPage.notice2Title": "최소 입금액",
  "depositPage.notice2Desc":
    "1회 입금 최소 금액은 0.001 BTC 또는 다른 코인의 등가 금액입니다. 이 금액 미만은 입금할 수 없습니다.",
  "depositPage.notice3Title": "확인 횟수 요구 사항",
  "depositPage.notice3Desc":
    "BTC는 3회, ETH/TRX/USDT는 12회의 네트워크 확인 후 잔액에 반영됩니다.",
  "depositPage.notice4Title": "자산 보안 주의",
  "depositPage.notice4Desc":
    "입금 주소와 프로토콜 유형을 신중히 확인하세요. 잘못된 작업은 자산의 영구적 손실로 이어질 수 있으며, 플랫폼은 책임을 지지 않습니다.",
  "depositPage.feeInfo": "💸 수수료: {fee}",

  // ===== 지갑 주소 연동 페이지 =====
  "bindAddress.title": "🔗 지갑 주소 연동",
  "bindAddress.desc": "출금용 암호화폐 지갑 주소 연동",
  "bindAddress.cardTitle": "➕ 새 지갑 연동",
  "bindAddress.selectCoin": "코인 선택",
  "bindAddress.selectProtocol": "프로토콜 선택",
  "bindAddress.walletAddress": "지갑 주소",
  "bindAddress.walletAddressPlaceholder": "지갑 주소를 입력하세요",
  "bindAddress.emailCode": "이메일 인증 코드",
  "bindAddress.emailCodePlaceholder": "이메일 인증 코드 입력",
  "bindAddress.resend": "{count}초 후 재전송",
  "bindAddress.sendCode": "인증 코드 전송",
  "bindAddress.confirmBind": "🔗 연동 확인",
  "bindAddress.noticeTitle": "📋 연동 시 주의사항",
  "bindAddress.twoFactorDesc":
    "이메일 인증 코드를 전송하려면 2단계 인증 코드를 입력하세요",
  "bindAddress.notice1Title": "자산 안전",
  "bindAddress.notice1Desc":
    "연동하는 지갑 주소가 본인 소유이며, 개인 키는 본인이 직접 관리하고 있음을 확인하세요.",
  "bindAddress.notice2Title": "출금 제한",
  "bindAddress.notice2Desc":
    "연동 후 24시간 이내에는 출금이 불가능합니다. 계정 자산을 보호하기 위함입니다.",
  "bindAddress.notice3Title": "이메일 인증",
  "bindAddress.notice3Desc":
    "새 지갑을 연동할 때마다 이메일 인증 코드를 통한 확인이 필요합니다.",
  "bindAddress.notice4Title": "주소 확인",
  "bindAddress.notice4Desc":
    "지갑 주소를 신중히 확인하세요. 잘못된 연동은 자산을 복구할 수 없게 만들 수 있습니다.",
  "bindAddress.msgAddressInvalid": "⚠️ 올바른 지갑 주소를 입력하세요",
  "bindAddress.msgCodeError": "인증 코드가 올바르지 않습니다",
  "bindAddress.msgFormInvalid":
    "모든 정보를 입력하고 이메일 인증 코드를 받으세요",

  // ===== 오류 페이지 =====
  "error.backHome": "홈으로 돌아가기",
  "error.refresh": "새로고침 후 재시도",
  "error.footerTip": "문제가 계속되면 기술 지원에 문의하세요",
  "error.title404": "페이지를 찾을 수 없음",
  "error.desc404": "접근한 페이지가 존재하지 않거나 삭제되었습니다",

  agreement: agreementContent,

  phase: "단계",

  country: {
    1: "미국",
    2: "중국",
    3: "일본",
    4: "한국",
    5: "독일",
    6: "영국",
    7: "프랑스",
    8: "아랍에미리트",
    9: "싱가포르",
    10: "이스라엘",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "발전 현황",
        content: usContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: usContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: usContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "발전 현황",
        content: cnContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: cnContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: cnContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "발전 현황",
        content: jpContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: jpContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: jpContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "발전 현황",
        content: koContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: koContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: koContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "발전 현황",
        content: geContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: geContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: geContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "발전 현황",
        content: ukContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: ukContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: ukContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "발전 현황",
        content: frContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: frContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: frContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "발전 현황",
        content: uaeContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: uaeContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: uaeContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "발전 현황",
        content: sgContent.t1,
      },
      t2: {
        title: "핵심 강점",
        content: sgContent.t2,
      },
      t3: {
        title: "직면한 과제",
        content: sgContent.t3,
      },
      t4: {
        title: "미래 트렌드",
        content: sgContent.t4,
      },
    },
  },

  // ===== 홈페이지-보충 (alt 속성 등) =====
  "home.altQr": "QR 코드를 스캔하여 다운로드",
  "home.altApp": "앱 스크린샷",
  "home.altWallet": "지갑 아이콘",

  // ===== 임대 상세 페이지 =====
  "detail.breadcrumbHome": "홈",
  "detail.breadcrumbRental": "서버 임대",
  "detail.breadcrumbDetail": "상세",
  "detail.badgeHot": "🔥 인기 추천",
  "detail.badgeAvailable": "✅ 임대 가능",
  "detail.badgeSold": "⏳ 만석",
  "detail.badgeEnded": "⏳ 종료됨",
  "detail.badgePending": "⏳ 시작 안됨",
  "detail.code": "코드: ",
  "detail.specTitle": "전체 사양",
  "detail.specGpu": "GPU 모델",
  "detail.specVram": "비디오 메모리 용량",
  "detail.specStorage": "스토리지 용량",
  "detail.specRam": "메모리",
  "detail.specBandwidth": "대역폭",
  "detail.specValue": "서버 가치",
  "detail.specCountry": "국가",
  "detail.specCountryFlag": "국기",
  "detail.specStatus": "상태",
  "detail.statusFull": "⏳ 만석",
  "detail.statusEnded": "⏳ 종료됨",
  "detail.statusPending": "⏳ 시작 안됨",
  "detail.statusAvailable": "✅ 임대 가능",
  "detail.chartTitle": "수익 트렌드",
  "detail.chartRealTime": "실시간",
  "detail.chartHint": "클릭하여 확대",
  "detail.chart7d": "7일",
  "detail.chart15d": "15일",
  "detail.chart30d": "30일",
  "detail.statMax": "최고",
  "detail.statAvg": "평균",
  "detail.statMin": "최저",
  "detail.statChange": "상승률",
  "detail.descTitle": "제품 설명",
  "detail.regionTitle": "지역 설명",
  "detail.panelTitle": "💎 지금 임대",
  "detail.statusDotFull": "● 만석",
  "detail.statusDotEnded": "● 종료됨",
  "detail.statusDotPending": "● 시작 안됨",
  "detail.statusDotAvailable": "● 임대 가능",
  "detail.activityPeriod": "📅 주기 시간",
  "detail.daysLeft": "잔여",
  "detail.days": "일",
  "detail.subscribeShare": "🎚️ 구매 지분",
  "detail.customShare": "맞춤 지분",
  "detail.incomeDetail": "📈 추정 수익 내역",
  "detail.incomeTip":
    "추정 수익은 참고용입니다. 실제 수익은 정산 데이터에 따릅니다.",
  "detail.estimate": "추정",
  "detail.rate": "수익률:",
  "detail.settleDate": "정산일:",
  "detail.moreStages": "추가 {count}단계",
  "detail.hoverExpand": "호버하여 확장",
  "detail.totalIncome": "추정 총 수익",
  "detail.fundDetail": "💰 자금 내역",
  "detail.rentalAmount": "임대 금액",
  "detail.maintenanceFee": "유지보수비",
  "detail.feeFormula": "총 가치*{percent}%*{fee}%",
  "detail.tierDiscount": "단계별 할인",
  "detail.subscribeTip": "(구매{percent}%)",
  "detail.discountDetail": "🎯 할인 단계 내역",
  "detail.subscribeGte": "구매 ≥ {percent}%",
  "detail.currentSubscribe": "현재 구매 {percent}%, 할인 -${discount}",
  "detail.total": "합계",
  "detail.btnFull": "⏳ 만석",
  "detail.btnEnded": "⏳ 종료됨",
  "detail.btnPending": "⏳ 시작 안됨",
  "detail.btnRent": "🚀 지금 임대",
  "detail.btnOutOfStock": "⏳ 품절",
  "detail.guaranteeSupport": "7×24 고객 지원",
  "detail.guaranteeData": "데이터 보안 보장",
  "detail.guaranteeSla": "99.9% SLA",
  "detail.recommendBadge": "🔄 당신에게 추천",
  "detail.recommendTitle1": "추천",
  "detail.recommendTitle2": "서버",
  "detail.recValue": "가치",
  "detail.recDetail": "자세히 보기 →",
  "detail.faqBadge": "❓ 자주 묻는 질문",
  "detail.faqTitle1": "임대",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 수익 트렌드 그래프",
  "detail.spec0": "입문형",
  "detail.spec1": "라이트형",
  "detail.spec2": "퍼포먼스형",
  "detail.spec3": "플래그십형",
  "detail.spec4": "슈퍼 플래그십",
  "detail.faq1Q": "서버 임대에 보증금이 필요한가요?",
  "detail.faq1A":
    "최초 임대 사용자의 경우 일정 비율의 보증금을 지불하셔야 할 수 있습니다. 장기 거래 고객은 보증금 감면 대상이 됩니다. 자세한 내용은 정산 페이지를 확인하세요.",
  "detail.faq2Q": "임대 기간 만료 후 갱신 방법은?",
  "detail.faq2A":
    "콘트롤 패널의 '내 임대' 페이지에서 갱신 절차를 할 수 있습니다. 일, 주, 월, 분기 단위로 갱신 가능하며, 갱신 가격은 현재 임대 가격과 동일합니다.",
  "detail.faq3Q": "서버에 장애가 발생하면 어떻게 하나요?",
  "detail.faq3A":
    "24시간 365일 기술 지원을 제공합니다. 하드웨어 장애 시 2시간 이내에 대응하고 24시간 이내에 수리 또는 교체를 완료합니다.",
  "detail.faq4Q": "임대를 조기에 종료할 수 있나요?",
  "detail.faq4A":
    "네, 가능합니다. 조기 종료 시 잔여 임대 기간의 30%에 해당하는 위약금이 발생합니다. 자세한 조건은 임대 시 '임대 서비스 계약'을 주의 깊게 읽어보세요.",
  "detail.faq5Q": "임대 서버의 데이터 보안은 어떻게 보장되나요?",
  "detail.faq5A":
    "엔터프라이즈급 데이터 암호화 기술을 채택하여 모든 데이터는 전송 및 저장 중에 암호화됩니다. 임대 종료 후 데이터는 완전히 삭제됩니다.",
  "detail.unitWan": "만",
  "detail.msgOutOfStock": "이 서버는 현재 품절입니다",
  "detail.msgSelectShare": "구매 지분을 선택하세요",
  "detail.msgRentFail": "임대 실패",
  "detail.msgRentSuccess": "임대 성공",
  "detail.msgContact": "고객 지원에 문의하세요: 400-888-8888",
  "detail.pwdTitle": "임대 확인",
  "detail.pwdLabel": "거래 비밀번호 입력",
  "detail.pwdPlaceholder": "거래 비밀번호 입력",
  "detail.pwdConfirm": "임대 확인",
  "detail.pwdCancel": "취소",
  "detail.rentNow": "💎 지금 임대",
  "detail.rentAmount": "임대 금액",
  "detail.subscribe": "구독",
  "detail.descProduct": "제품 설명",
  "detail.descRegion": "지역 정보",
  "detail.rentNowBtn": "🚀 지금 임대",
  "detail.outOfStock": "⏳ 일시적으로 품절",
  "detail.stages": "단계",
  "detail.discount": "할인",
  "detail.rentConfirm": "임대 확인",
  "detail.enterPassword": "거래 비밀번호를 입력하세요",
  "detail.confirmRent": "임대 확인",
  "detail.cancel": "취소",
  "detail.outOfStockMsg": "이 서버는 일시적으로 품절되었습니다",
  "detail.selectShareMsg": "구독 지분을 선택하세요",
  "detail.rentFail": "임대 실패",
  "detail.rentSuccess": "임대 성공",
  "detail.contactService": "고객센터에 문의하세요: 400-888-8888",
  "detail.tenThousand": "만",

  // ===== 컴퓨팅 정보 페이지 =====
  "info.emptyTitle": "현재 컴퓨팅 서버가 없습니다",
  "info.emptyDesc":
    "출시 예정입니다. 더 많은 우수한 컴퓨팅 리소스를 준비 중입니다",
  "info.collapse": "접기",
  "info.expand": "펼치기",
  "info.collapseDetail": "상세 정보 접기",
  "info.expandDetail": "상세 정보 펼치기",
  "info.priceTrend": "📈 가격 트렌드",
  "info.unit": "단위",
  "info.latestPrice": "최신 가격",
  "info.lastPrice": "전일 가격",
  "info.increase": "상승률",
  "info.buyNow": "지금 구매",
  "info.buyCompute": "컴퓨팅 파워 구매",
  "info.selectPeriod": "기간 선택",
  "info.day": "일",
  "info.periodTime": "기간",
  "info.purchaseQuantity": "구매 수량",
  "info.expectedProfit": "추정 수익",
  "info.profitTip":
    "추정 수익은 과거 평균값입니다. 실제 수익은 정산 데이터에 따릅니다.",
  "info.baseProfit": "기본 수익",
  "info.settle24h": "24시간 정산",
  "info.periodProfit": "기간 수익",
  "info.settleDue": "만료 정산",
  "info.totalProfit": "총 수익",
  "info.fundDetail": "자금 내역",
  "info.purchaseAmount": "구매 금액",
  "info.buyFormula": "최신 가격 x 구매 수량",
  "info.fee": "수수료",
  "info.feeFormula": "구매 금액 * {fee}%",
  "info.total": "합계",
  "info.cancel": "취소",
  "info.confirmBuy": "구매 확인",
  "info.tradeConfirm": "거래 확인",
  "info.enterPassword": "거래 비밀번호 입력",
  "info.confirmPay": "결제 확인",
  "info.chart7d": "7일",
  "info.chart15d": "15일",
  "info.chart30d": "30일",
  "info.price": "가격",
  "info.maxValue": "최대값",
  "info.noData": "데이터가 없습니다",
  "info.fetchFail": "데이터를 가져오지 못했습니다",
  "info.selectProduct": "제품을 선택하세요",
  "info.quantityMin": "구매 수량은 1 이상이어야 합니다",
  "info.priceError": "현재 가격이 비정상입니다. 잠시 후 다시 시도하세요",
  "info.buySuccess": "구매 성공!",
  "info.tradeFail": "거래에 실패했습니다. 잠시 후 다시 시도하세요",
  "info.passwordError": "거래 비밀번호가 올바르지 않습니다. 다시 입력하세요",
  "info.buyFail": "구매에 실패했습니다. 잠시 후 다시 시도하세요",

  // ===== 회사 소개 페이지 =====
  "about.tocTitle": "📑 목차",
  "about.toc1": "디지털 골드 장악하기",
  "about.toc2": "핵심 제품 매트릭스",
  "about.toc3": "Aetrivol의 안전성과 신뢰성",
  "about.toc4": "투자 가치",
  "about.section1Title":
    "디지털 골드 장악하기: 인텔리전트 시대의 '슈퍼 뉴 컴퓨팅 로드' 되기",
  "about.section1P1":
    "글로벌 대형 모델이 조 단위 매개변수의 결전에 돌입하고, 구체화된 지능이 전면적으로 폭발하는 오늘날, 컴퓨팅 파워는 석유를 대체하여 세계 부를 지배하는 궁극의 하드 커런시가 되었습니다. 기술 대기업들은 GPU를 미친 듯이 사들이고, 수억에 달하는 AI 컴퓨팅 센터 건설 비용은 일반 투자자를 배제하고 있습니다. Aetrivol은 시대에 맞춰 탄생했습니다. 혁신적인 컴퓨팅 파워 값 앵커링 메커니즘과 컴퓨팅 서버 임대 모델을 통해 자산 독점을 깨고, 가장 간단하고 유연한 방법으로 인류 역사상 가장 큰 부의 복리 향연을 직접 누릴 수 있습니다.",
  "about.section2Title": "핵심 제품 매트릭스: 트윈 휠 구동 부의 엔진",
  "about.section2H1":
    "혁신 제품 1: [컴퓨팅 파워 값 (Compute Value / CV)] —— 글로벌 컴퓨팅 자산의 '토큰화된 배당'",
  "about.section2P1":
    "· 진입 장벽을 허물고, 미세 자산화: 글로벌 물리적 AI 컴퓨팅 센터, 하이엔드 GPU 서버 (NVIDIA Blackwell, Huawei Ascend 등)의 전체 컴퓨팅 파워를 표준화하여 분할합니다. 1포인트의 [컴퓨팅 파워 값]은 글로벌 AI 컴퓨팅 네트워크에서 특정 지분의 컴퓨팅 소유권을 나타냅니다.",
  "about.section2P2":
    "· 펀드 사듯 GPU 구매: 최소한의 자금으로 [컴퓨팅 파워 값]을 구매하면 'GPU 한 장도 구하기 힘든' 장벽을 허물 수 있습니다. 보유한 컴퓨팅 파워 값은 플랫폼에서 24시간 가동되며, 글로벌 대형 AI 모델 및 에이전트 호출로 창출되는 디지털 현금 흐름 배당금을 매일 받을 수 있습니다.",
  "about.section2P3":
    "· 높은 유동성, 언제든 현금화: 컴퓨팅 파워 값은 매우 높은 자산 유동성을 갖습니다. 글로벌 컴퓨팅 수요의 급증에 따라 컴퓨팅 파워 값 자체에 높은 프리미엄 여력이 있으며, 언제든 플랫폼에서 거래하여 현금화할 수 있습니다.",
  "about.section2H2":
    "핵심 사업 2: [컴퓨팅 서버 임대 (Server Leasing)] —— 안정적인 장기 계약의 '디지털 집주인' 모델",
  "about.section2P4":
    "· 물리 자산 구매, 전용 서버 소유권: 투자자는 플랫폼의 서버 전체 또는 표준 랙의 컴퓨팅 서버를 직접 구매할 수 있습니다. 각 서버는 체인 상에 실제로 매핑되며, 고유한 물리적 머신 SN 코드를 가집니다.",
  "about.section2P5":
    "· 장기 위탁 임대, 안정적인 높은 임대료 수익: 구매 후 서버는 플랫폼의 글로벌 그린 컴퓨팅 허브 (중국 서부 동수서산 노드, 북유럽, 중동 등)의 최고급 AI 컴퓨팅 센터에 직접 위탁됩니다. 플랫폼이 대신 서버를 컴퓨팅 파워를 긴급히 필요로 하는 대형 모델 개발사, 대학 연구소, 또는 수직 분야 AI 기업에 정확히 임대하여 3~5년의 장기 계약을 통한 안정적인 고수익 임대료를 확보합니다.",
  "about.section3Title": "Aetrivol이 위험을 절대적 확실성으로 바꾸는 이유",
  "about.section3P1":
    "· 100% 물리 자산의 체인 상 앵커링: 공중 누각을 거부합니다. 보유한 컴퓨팅 파워 값이든 임대하는 서버든, 체인 상에서 실시간으로 병렬 가동되며 굉음을 내는 물리적 가속기 카드 하드웨어에 매핑되어 있어, 자산은 보이고, 만져지고, 검증 가능합니다.",
  "about.section3P2":
    "· 최고 수준의 에너지 효율과 '지정학적 리스크'에 대한 이중 보험: 당사가 패키징하는 데이터 센터는 100% '소형 모듈 원자로 (SMR)/태양광 직접 공급' 전력을 갖추거나, 절대적으로 안전한 비분쟁 법적 관할권에 위치하여 지역적 전력망 문제나 지정학적 변동의 위험을 완전히 회피합니다.",
  "about.section3P3":
    "· 대기업의 신용 보증 및 장기 계약 보장: 플랫폼은 Microsoft, OpenAI, DeepSeek 등 대형 모델 거대 기업이 사전에 임대를 확보한 성숙한 사이트를 우선적으로 선택하여, 기술 대기업의 신용을 수익 보증으로 활용합니다.",
  "about.section4Title":
    "과거 그들은 땅에 투자하고, 석유에 투자했습니다. 오늘날 우리는 컴퓨팅 파워에 투자합니다.",
  "about.section4P1":
    "전 인류의 지성과 비즈니스가 디지털 세계로 이전될 때, 컴퓨팅 파워는 이 새로운 세계의 유일한 건축 자재입니다. Aetrivol에 참여하고, 컴퓨팅 파워 값을 구매하고, 컴퓨팅 서버 임대 여정을 시작하세요. 귀하의 자본을 세계를 재형성하는 컴퓨팅 원자로 변환하고, 이 지능 급증의 부의 급등을 함께 누리십시오!",
};
